import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// import type { RootState } from "@/lib/store";
import { getAuthToken } from '@/lib/auth';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:7845';

interface TranslationRequest {
  fromText: string
  toText: string
  direction: 'E2G' | 'G2E'
}

interface TranslationResponse {
  _id: string
  userId: string
  month: string
  translations: {
    fromText: string
    toText: string
    direction: 'E2G' | 'G2E' // English To Gujarati && Gujarati To English
  }[]
}

export const translationApi = createApi({
  reducerPath: 'translationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/api`,
    prepareHeaders: (headers, { getState }) => {
      // 1) preferred: read token from redux auth slice
      // const token = (getState() as RootState).auth?.token;

      // 2) fallback: read from localStorage if you use it
      const token = getAuthToken();

      const authToken = token || null;
      if (authToken) {
        headers.set("Authorization", `Bearer ${authToken}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    createTranslation: builder.mutation<void, TranslationRequest>({
      query: (body) => ({
        url: '/translation',
        method: 'POST',
        body
      })
    }),
    getMonthlyTranslations: builder.query<TranslationResponse, { userId: string; month?: string }>({
      query: ({ month }) => ({
        url: `/translation?${month ? `&month=${month}` : ''}`,
        method: 'GET'
      })
    })
  })
})

export const { useCreateTranslationMutation, useGetMonthlyTranslationsQuery } = translationApi
